import axios from "axios";
import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import { ParamUtil, RequestParam } from "../../utils/paramUtil";
import { HeadersUtil } from "../../utils/headersUtil";

export class Dcs0201Service {
  private static _dcs0201Service: Dcs0201Service;

  public static getInstance(): Dcs0201Service {
    if (!Dcs0201Service._dcs0201Service) {
      Dcs0201Service._dcs0201Service = new Dcs0201Service();
    }
    return Dcs0201Service._dcs0201Service;
  }

  public getList(modelSearch: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(modelSearch);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getLstDelivery.do",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDeliveryDetail(deliveryId: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(deliveryId);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getDeliveryDetail.do",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateDelivery(req: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/update.do"
    );
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public insertDelivery(req: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/insert.do"
    );
    return axios.post(url, req, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public delete(deliveryId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL +
        "/dcs/dcs0201/" +
        deliveryId +
        "/deleteDelivery.do"
    );
    return axios.delete(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDataByCollectionNm(req: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(req);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getData.do",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getListDataMap(modelSearch: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(modelSearch);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getDataMap.do",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public addDataMap(data: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/addDataMap.do"
    );
    return axios.post(url, data, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateDataMap(data: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/updateDataMap.do"
    );
    return axios.post(url, data, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDataMapById(dataMapId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL +
        "/dcs/dcs0201/getDataMapById.do?dataMapId=" +
        dataMapId
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public getDataMapByConnType(connType: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL +
        "/dcs/dcs0201/getDataMapByConnType.do?connType=" +
        connType
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public deleteDataMap(dataMapId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL +
        "/dcs/dcs0201/deleteDataMap.do?dataMapId=" +
        dataMapId
    );
    return axios.delete(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public exportExcelTemplate(param: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(param);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/download-excel",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
      responseType: "blob",
    });
  }
  public getProVer() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getProtocolVer"
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }
  public getProVerTree(modelSearch: any) {
    const params: RequestParam[] = ParamUtil.toRequestParams(modelSearch);
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/getProtocolVerTree",
      params
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }
  public changeSttDataMapping(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/changeSttDataMapping"
    );
    return axios.put(url, param, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }

  public updateDataMapping(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_MAIN_URL + "/dcs/dcs0201/updateDataMapping"
    );
    return axios.put(url, param, {
      headers: HeadersUtil.getHeadersAuth(),
    });
  }
}
